var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16.5,
    viewBox: "0 0 20 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Tip-flag"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 20,
    height: 16.5,
    transform: "translate(510 317)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_460",
    "data-name": "Mask Group 460",
    transform: "translate(-510 -317)",
    clipPath: "url(#Tip-flag)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_59_",
    "data-name": "svgexport-6 (59)",
    transform: "translate(511.75 317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10557",
    "data-name": "Group 10557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10713",
    "data-name": "Path 10713",
    d: "M15.75,5.6H9.6l-.29-.309-.29-2.154L9.306.671h7.027a.166.166,0,0,1,.144.249L15.173,3.2a.166.166,0,0,0,0,.165l1.1,1.926Z",
    fill: "#f2b636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10553",
    "data-name": "Group 10553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10552",
    "data-name": "Group 10552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10551",
    "data-name": "Group 10551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10714",
    "data-name": "Path 10714",
    d: "M9.306,5.288l-.29.309.29.29h7.027a.166.166,0,0,0,.144-.249l-.2-.35Z",
    fill: "#e8aa28"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10715",
    "data-name": "Path 10715",
    d: "M8.764,8.932,9.306,8.7V.542a.542.542,0,0,0-1.084,0V8.551Z",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10716",
    "data-name": "Path 10716",
    d: "M9.306,8.7a3.953,3.953,0,0,0-1.084-.144v.6l.542.324.542-.18Z",
    fill: "#d66e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10554",
    "data-name": "Group 10554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10717",
    "data-name": "Path 10717",
    d: "M8.255,14.774h2.423a.624.624,0,0,0,.653-.728.718.718,0,0,0-.653-.418l-1.1-.29-1.034.29h-.29a.718.718,0,0,0-.653.418A.624.624,0,0,0,8.255,14.774Z",
    fill: "#f4b184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10718",
    "data-name": "Path 10718",
    d: "M8.58,16.21h1.441a.618.618,0,0,0,.662-.707.719.719,0,0,0-.662-.438l-.555-.29-.6.29H8.58a.719.719,0,0,0-.653.418A.624.624,0,0,0,8.58,16.21Z",
    fill: "#f4b184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10719",
    "data-name": "Path 10719",
    d: "M7.792,12.193a.719.719,0,0,0-.653.418.624.624,0,0,0,.653.728H11.13a.624.624,0,0,0,.653-.728.719.719,0,0,0-.653-.418L9.712,11.9l-1.426.29Z",
    fill: "#f4b184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10720",
    "data-name": "Path 10720",
    d: "M8,10.757h3.657a.718.718,0,0,1,.653.418.624.624,0,0,1-.653.728H8a.618.618,0,0,1-.662-.707A.718.718,0,0,1,8,10.757Z",
    fill: "#f4b184"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10721",
    "data-name": "Path 10721",
    d: "M10.677,14.465H8.255a.717.717,0,0,1-.652-.419.717.717,0,0,0,.652,1.017h2.423a.717.717,0,0,0,.652-1.017A.717.717,0,0,1,10.677,14.465Z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10722",
    "data-name": "Path 10722",
    d: "M10.021,15.9H8.58a.718.718,0,0,1-.652-.419A.717.717,0,0,0,8.58,16.5h1.441a.717.717,0,0,0,.652-1.017A.718.718,0,0,1,10.021,15.9Z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10723",
    "data-name": "Path 10723",
    d: "M11.13,13.03H7.792a.718.718,0,0,1-.652-.419.717.717,0,0,0,.652,1.017H11.13a.717.717,0,0,0,.652-1.017A.718.718,0,0,1,11.13,13.03Z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10724",
    "data-name": "Path 10724",
    d: "M11.653,11.594H8a.717.717,0,0,1-.652-.419A.717.717,0,0,0,8,12.193h3.657a.717.717,0,0,0,.652-1.017A.717.717,0,0,1,11.653,11.594Z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10725",
    "data-name": "Path 10725",
    d: "M8.151,15.782a.718.718,0,0,1,.718-.718H8.545a.718.718,0,0,1,0-1.436H8.082a.718.718,0,1,1,0-1.436h.2a.718.718,0,1,1,0-1.436h.141l.307,1.436.032.151a1.043,1.043,0,0,0,.818.794,1.131,1.131,0,0,0,.223.023.388.388,0,0,0,.4-.38V10.386c0-1.532-2.368-1.346-4.465-.99A4.978,4.978,0,0,0,3.52,10.53a.957.957,0,0,1-.62.227H2.261l-.58,2.078.58,1.769.29.309h.342a1.437,1.437,0,0,1,.922.336,4.963,4.963,0,0,0,2.833.96H7.71s.508.031.452-.309a.72.72,0,0,1-.01-.119Z",
    fill: "#ffc89f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10555",
    "data-name": "Group 10555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10726",
    "data-name": "Path 10726",
    d: "M8.162,15.9H6.648a4.339,4.339,0,0,1-2.533-.96,1.437,1.437,0,0,0-.922-.336H2.261l-.29.261.29.337h.632a1.437,1.437,0,0,1,.922.336,4.963,4.963,0,0,0,2.833.96H8.87a.718.718,0,0,1-.708-.6Z",
    fill: "#f7bc94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10727",
    "data-name": "Path 10727",
    d: "M8.4,10.625a.166.166,0,0,0-.2-.127l-.619.161a.251.251,0,0,0-.179.18,3.394,3.394,0,0,1-1.923,2.086.257.257,0,0,0-.15.318.249.249,0,0,0,.33.147,3.861,3.861,0,0,0,2.183-2.284l.631-.164Z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10728",
    "data-name": "Path 10728",
    d: "M1.971,15.175H.29L0,14.866v-4.2A.166.166,0,0,1,.166,10.5H2.095a.166.166,0,0,1,.166.166v4.2Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10729",
    "data-name": "Path 10729",
    d: "M.166,15.465H2.095a.166.166,0,0,0,.166-.166v-.432H0V15.3A.166.166,0,0,0,.166,15.465Z",
    fill: "#7e59d1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipFlag);
export default __webpack_public_path__ + "static/media/Tip-flag.4da6a366cc22387bc4ee4806481663af.svg";
export { ForwardRef as ReactComponent };